import { useMemo } from "react";
import { Locale } from "date-fns";
import { de, enUS } from "date-fns/locale";

type LocaleConfig = {
  format: string;
  locale: Locale;
  placeholder: string;
};

const supportedLocales: { [key: string]: LocaleConfig } = {
  "en-US": {
    format: "MM/dd/yyyy",
    locale: enUS,
    placeholder: "MM/DD/YYYY",
  },
  de: {
    format: "dd.MM.yyyy",
    locale: de,
    placeholder: "TT.MM.JJJJ",
  },
};

const defaultLocale: LocaleConfig = supportedLocales["en-US"];

const useUserLocale = (): LocaleConfig => {
  const userLocale = useMemo(() => {
    const locale = navigator.language;
    return supportedLocales[locale] ? locale : "en-US";
  }, []);

  return supportedLocales[userLocale] || defaultLocale;
};

export default useUserLocale;
